/**
 * BreadcrumbBar — bande fil d'Ariane, rendue en haut du panel center.
 *
 * @remarks
 * Chrome shell agnostique au métier : lit les items publiés par la vue center
 * courante (`useBreadcrumb` → store partagé) et les rend. Ne rend rien quand la
 * vue n'a pas publié de fil d'Ariane (pages de premier niveau).
 */

import { Breadcrumb, useBreadcrumbStore } from '@/shared/components';

export function BreadcrumbBar() {
  const items = useBreadcrumbStore((s) => s.items);
  const actions = useBreadcrumbStore((s) => s.actions);

  if (items.length === 0 && !actions) return null;

  // `--panel-header-height` = hauteur des barres d'onglets latérales (PanelTabs)
  // → bordure basse alignée entre les panneaux.
  // breadcrumb à gauche (flux normal), actions centrées en absolu.
  return (
    <div className="border-border bg-surface relative flex h-(--panel-header-height) shrink-0 items-center border-b px-4">
      <Breadcrumb items={items} />
      {actions && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{actions}</div>
      )}
    </div>
  );
}
